import { CaseError } from 'modules/cm/domain/Case/Error';
import { Nullable } from 'utils/types';
import { Action, Actions } from './store';

export interface State {
  error: Nullable<CaseError>;
}

const initialState: State = {
  error: null,
};

const reducer = (state: State = initialState, action: Action) => {
  const map = new Map([
    [
      Actions.SET_ERROR,
      () => ({
        ...state,
        error: action.payload,
      }),
    ],
  ]);

  const actionCallback = map.get(action.type);

  return actionCallback ? actionCallback() : state;
};

export default reducer;
